import { AlertTriangle, CheckCircle2 } from 'lucide-react'
import Button from '@components/web/Button'

type StatusModalProps = {
  type: 'success' | 'error'
  title: string
  message: string
  primaryLabel?: string
  secondaryLabel?: string
  onPrimary: () => void
  onSecondary?: () => void
}

export default function StatusModal({
  type,
  title,
  message,
  primaryLabel = 'OK',
  secondaryLabel,
  onPrimary,
  onSecondary,
}: StatusModalProps) {
  const isSuccess = type === 'success'
  const Icon = isSuccess ? CheckCircle2 : AlertTriangle

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-card p-6 shadow-xl">
        <div className="flex flex-col items-center text-center">
          <div className={isSuccess ? 'rounded-full bg-emerald-100 p-3 text-emerald-600' : 'rounded-full bg-destructive/10 p-3 text-destructive'}>
            <Icon size={26} />
          </div>
          <h3 className="mt-4 text-lg font-bold text-foreground">{title}</h3>
          <p className="mt-2 text-sm leading-6 text-muted-foreground">{message}</p>
        </div>

        <div className="mt-6 flex gap-3">
          {secondaryLabel && onSecondary && (
            <Button variant="outline" className="flex-1" onClick={onSecondary}>
              {secondaryLabel}
            </Button>
          )}
          <Button
            variant={isSuccess ? 'primary' : 'destructive'}
            className="flex-1"
            onClick={onPrimary}
          >
            {primaryLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}